// extracted by mini-css-extract-plugin
export default {"header":"Datatypes_header__lkvSo","arrowIcon":"Datatypes_arrowIcon__CMtf6"};